<script>
  import { createEventDispatcher } from 'svelte';
  import Conexoes from '../../Classes/Conexoes.js';
  import Constantes from '../../Classes/Constantes.js';
  import { tenantLogado } from '../../Classes/Stores.js';

  export let locais = [];
  const dispatch = createEventDispatcher();
  const conexao = new Conexoes();
  $: tenant = $tenantLogado;

  let nomeLocal = '';
  let enderecoLocal = '';

  async function salvarLocal() {
    if (!nomeLocal) { dispatch('recarregar', 'O nome do local é obrigatório.'); return; }
    dispatch('loading', true);
    
    // Adicione a rota api_salvar_local no seu Constantes.js, ou use string direta
    const url = Constantes.api_acesso.replace('acesso.php', 'salvar_local.php');
    const res = await conexao.conecta(url, {
      body: { id_tenant: tenant.id, nome: nomeLocal, endereco: enderecoLocal, acao: 'salvar' }
    });
    
    dispatch('loading', false);
    nomeLocal = ''; enderecoLocal = '';
    dispatch('recarregar', res?.mensagem || 'Local guardado!');
  }

  async function apagarLocal(id) {
    if (!confirm("Apagar este local? Ele não aparecerá nas próximas gerações.")) return;
    dispatch('loading', true);
    const url = Constantes.api_acesso.replace('acesso.php', 'salvar_local.php');
    await conexao.conecta(url, { body: { id_tenant: tenant.id, id_local: id, acao: 'apagar' } });
    dispatch('loading', false);
    dispatch('recarregar');
  }
</script>

<section class="card-panel fade-in">
  <h2>Gerenciar Locais de Atendimento</h2>
  <div class="tip-box mb-4">
  <i class="fas fa-lightbulb"></i>
  <div>
    <strong>Dica de Estratégia:</strong> Esta aba é o coração da sua organização! 
    Você pode cadastrar muito mais do que endereços físicos. Use para diferenciar:
    <ul class="mt-2" style="padding-left: 20px;">
      <li><strong>Modalidades:</strong> "Atendimento Online (Zoom/Meet)", "Atendimento Domiciliar".</li>
      <li><strong>Multi-Clínicas:</strong> "Consultório Centro", "Consultório Zona Sul".</li>
      <li><strong>Serviços Distintos:</strong> "Agendamento Unhas", "Agendamento Cabelo" (se o seu fluxo exigir locais separados para cada serviço).</li>
    </ul>
  </div>
</div>
  <div class="form-grid" style="background: var(--bg-app); padding: 20px; border-radius: 12px; margin-bottom: 20px;">
    <div>
      <label>Nome do Local (Ex: Clínica X, Zoom)</label>
      <input type="text" class="input-app" bind:value={nomeLocal} placeholder="Nome identificador" />
    </div>
    <div>
      <label>Endereço / Link Completo</label>
      <input type="text" class="input-app" bind:value={enderecoLocal} placeholder="Rua, Número ou Link" />
    </div>
    <div class="grid-full">
      <button class="btn-primary" on:click={salvarLocal}><i class="fas fa-save"></i> Adicionar Local</button>
    </div>
  </div>

  <div class="table-scroll mt-4">
    <table class="app-table">
      <thead><tr><th>Nome</th><th>Endereço/Link</th><th>Ação</th></tr></thead>
      <tbody>
        {#each locais as loc}
          <tr>
            <td class="fw-bold">{loc.nome}</td>
            <td><span class="text-muted">{loc.endereco || '-'}</span></td>
            <td><button class="btn-del" on:click={() => apagarLocal(loc.id)}><i class="fas fa-trash"></i></button></td>
          </tr>
        {:else}
          <tr><td colspan="3" class="text-center text-muted">Nenhum local cadastrado.</td></tr>
        {/each}
      </tbody>
    </table>
  </div>
</section>

<style>
  .form-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 15px; }
  .grid-full { grid-column: 1 / -1; }
  .text-center { text-align: center; }
  @media (max-width: 900px) { .form-grid { grid-template-columns: 1fr; } }
  @media (max-width: 640px) {
    .form-grid { gap: 12px; }
    .tip-box { flex-direction: column; }
    .table-scroll { overflow-x: auto; }
  }
  .tip-box {
  background: #fff9e6;
  border-left: 4px solid #f6ad55;
  padding: 15px 20px;
  border-radius: 8px;
  display: flex;
  gap: 15px;
  color: #744210;
  font-size: 0.9rem;
  line-height: 1.5;
}
.tip-box i {
  font-size: 1.2rem;
  color: #f6ad55;
  margin-top: 3px;
}
.mb-4 { margin-bottom: 20px; }
.mt-2 { margin-top: 8px; }
</style>